var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ElRow',{attrs:{"gutter":20}},[_c('ElCol',{attrs:{"span":12}},[_vm._v(" Subject Name - Common Name (CN): ")]),_c('ElCol',{attrs:{"span":12}},[_c('code',[_vm._v(_vm._s(_vm.commonName))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }